
import { IDataTableColumn } from "src/classes";
import Vue, {PropOptions} from "vue";
import AppDataTableRowCell from "./DataTableRowCell.vue";

export default Vue.extend({
	props: {
		item: {
			type: Object as ()=> any
		},
		columns: {
			type: Array as () => IDataTableColumn[],
			default: () => []
		} as PropOptions<any>,
		selected: Boolean,
		useCheckboxes: Boolean,
		getStyleFunction: {
			type: Function// as (item:any)=>any,
		},
		widths: {
			type: Object as ()=>string[],
			required: true
		},
		compact: {
			type: Boolean,
			default: false
		},
	},
	computed: {
		style():any{
			if (this.selected) return null;
			if (!this.getStyleFunction) return null;
			return this.getStyleFunction(this.item);
		},
		extraClasses():any{
			if (this.item.getBrowseClass){
				let extraClasses = this.item.getBrowseClass();
				let result = {} as any;
				for (let key of extraClasses){
					result[key] = true;
				}
				return result;
			}
			return {};
		},
	},
	components: {
		AppDataTableRowCell
	}
});
